import { render } from "./nosto.vue?vue&type=template&id=078d8af6"
import script from "./nosto.vue?vue&type=script&lang=js"
export * from "./nosto.vue?vue&type=script&lang=js"

import exportComponent from "/home/djordje/code/uwp/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__